var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglenew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.84 12.2219C21.84 11.5741 21.7815 10.9592 21.6809 10.3604H12.2139V14.0584H17.6345C17.3914 15.2722 16.6795 16.2969 15.6235 16.9941V19.4539H18.8576C20.751 17.7403 21.84 15.2144 21.84 12.2213V12.2219Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2136 21.84C14.9279 21.84 17.1985 20.9543 18.8573 19.4536L15.6232 16.9938C14.7183 17.5843 13.5707 17.9451 12.2136 17.9451C9.59133 17.9451 7.37127 16.2148 6.57539 13.8779H3.24023V16.4117C4.89052 19.626 8.28366 21.84 12.2131 21.84H12.2136Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57528 13.8779C6.36567 13.2874 6.25714 12.6564 6.25714 12.0003C6.25714 11.3442 6.37418 10.7131 6.57528 10.1226V7.58887H3.24066C2.55384 8.91666 2.16016 10.4095 2.16016 12.0003C2.16016 13.591 2.55384 15.0834 3.24066 16.4117L6.57528 13.8779Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2136 6.05502C13.6963 6.05502 15.0205 6.55542 16.0675 7.53122L18.9328 4.72671C17.1985 3.13596 14.9279 2.16016 12.2136 2.16016C8.28419 2.16016 4.89105 4.37419 3.24023 7.58849L6.57485 10.1222C7.37074 7.78532 9.5908 6.05502 12.2131 6.05502H12.2136Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglenew);
export default __webpack_public_path__ + "static/media/Googlenew.fac7708b89d312be374bb129f10e24f8.svg";
export { ForwardRef as ReactComponent };